import { useQuery } from '@pinia/colada';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { useCompanyQuery } from '@tallo/investor/company';

import propertyInquiryService from '../services/property-inquiry.service';
import { getPropertyInquiriesQueryKey } from './property-inqiries.query';

/**
 * Under the unit's inquiries key, so whatever refreshes those (an application sent, accepted or declined, the unit
 * paused or rented out) refreshes this list too.
 */
export function getPropertyWantsToApplyQueryKey(propertyId: string) {
  return [...getPropertyInquiriesQueryKey(propertyId), 'wants-to-apply'];
}

/** Renters waiting for the owner to send them an application on the route's unit, newest ask first. */
export function usePropertyWantsToApplyQuery() {
  const route = useRoute();
  const propertyId = computed(() => route.params.propertyId as string);

  return useQuery({
    key: () => getPropertyWantsToApplyQueryKey(propertyId.value),
    query: () => propertyInquiryService.getWantsToApplyByProperty(propertyId.value),
  });
}

export function getCompanyWantsToApplyQueryKey() {
  return ['wants-to-apply'];
}

/** The same across the units the owner works, leaving out units rented out or taken down. */
export function useCompanyWantsToApplyQuery() {
  return useQuery({
    key: () => getCompanyWantsToApplyQueryKey(),
    query: async () => {
      const companyQuery = useCompanyQuery();
      const { data } = await companyQuery.refresh(true);

      return propertyInquiryService.getWantsToApplyByCompany(data!.id);
    },
  });
}
